import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  token: string;
};

const initialState: StateInterface = {
  isFetching: false,
  token: ""
};

export const tokenReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.TOKEN_UPDATE:
      return {
        ...state,
        token: action.payload?.token,
        isFetching: false
      };
    case Constants.TOKEN_CHECK:
      return {
        ...state,
        isFetching: true
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
